/*
 * This code was generated with assistance from GitHub Copilot.
 * De-bundled from react-dxd-components@0.1.33 compiled dist/index.js (webpack module id 8).
 */
import * as React from 'react';
import type { ButtonHTMLAttributes, CSSProperties, ReactNode } from 'react';
import classNames from './classnames-vendor';

export interface ButtonProps extends Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'className'> {
  /** Text to display inside the button */
  children: ReactNode;
  /** Creates a secondary (outline) button */
  secondary?: boolean;
  /** Creates a tertiary (flat) button */
  tertiary?: boolean;
  /**
   * Creates a disabled button.
   * Can be added to any button type
   */
  disabled?: boolean;
  /**
   * Reverses the button colors for better display on a dark background.
   *  Can be added to any button type  (synonym for "inverted")
   */
  reversed?: boolean;
  /**
   * Inverts the button colors for better display on a dark background.
   *  Can be added to any button type (synonym for "reversed")
   */
  inverted?: boolean;
  /** Creates a full width button
   * Can be added to any button type
   */
  fullWidth?: boolean;
  /** String of additional classes to add to the button.  Useful for adding
   * utility classes if needed.
   */
  className?: string;
  /** Used to display the loading spinner instead of the button.
   *  If not added, normal button will display
   */
  loading?: boolean;
}

const Button = ({
  children,
  secondary = false,
  tertiary = false,
  disabled = false,
  reversed = false,
  inverted = false,
  fullWidth = false,
  onClick = () => {},
  className = '',
  loading = false,
  ...otherProps
}: ButtonProps) => {
  const classes = classNames(
    'Button',
    { 'Button--full': fullWidth },
    { 'Button--white': reversed || inverted },
    { 'Button--outline': secondary },
    { 'Button--flat': tertiary },
    { 'is-disabled': disabled },
    className
  );

  const loadStyle: CSSProperties = {
    zIndex: 1,
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginLeft: '-10px',
    marginTop: '-10px',
  };
  const childStyle: CSSProperties = loading ? { zIndex: -1, position: 'relative' } : {};

  return (
    <button type="button" disabled={disabled} className={classes} onClick={onClick} {...otherProps}>
      {loading && (
        <svg style={loadStyle} className="Loader" width="20px" height="20px" role="img">
          <circle cx="10" cy="10" r={8} fill="none" />
        </svg>
      )}
      <div style={childStyle}>{children}</div>
    </button>
  );
};

export default Button;


